import { Component } from '@angular/core';
import { exportJs } from "../../../assets/js/theme.js";
@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent {
  ngOnInit() {
    exportJs()
  }
}
